<template>
  <el-upload
    ref="resourcesUp"
    action=""
    :accept="accept"
    :auto-upload="autoUpload"
    :http-request="enclosureUpload"
    :on-exceed="handleExceed"
    :on-remove="handleRemove"
    :before-remove="beforeRemove"
    :multiple="multiple"
    :limit="limit"
    :drag="drag"
    :show-file-list="showFileList"
    :before-upload="beforeUpload"
    :file-list="fileList"
  >
    <template>
      <div v-if="drag">
        <i class="el-icon-upload" />
        <div class="el-upload__text">{{ uploadText }}</div>
      </div>
      <div v-else>
        <!-- 选取文件 -->
        <el-button
          slot="trigger"
          size="small" type="primary"
          style="margin-right: 5px"
        >{{ $t('spareNumberPoo.SelectTheFile') }}</el-button>
      </div>

      <div slot="tip" class="el-upload__tip">{{ tips }}</div>
    </template>

    <!--    <template v-else>-->
    <!--      &lt;!&ndash; 选取文件 &ndash;&gt;-->
    <!--      <el-button-->
    <!--        slot="trigger"-->
    <!--        size="small" type="primary"-->
    <!--        style="margin-right: 5px"-->
    <!--      >{{ $t('spareNumberPoo.SelectTheFile') }}</el-button>-->
    <!--      <div slot="tip" class="el-upload__tip">{{ tips }}</div>-->
    <!--    </template>-->
  </el-upload>
</template>

<script>
import { uploadOos } from '@/utils/ali_oos_util';
import i18n from '@/lang/index.js';

export default {
  props: {
    // 回显文件列表
    fileArr: {
      type: Array,
      default: () => []
    },

    // 文件在服务器上的文件夹名称
    serverFolderName: {
      type: String,
      default: 'workOrder'
    },

    // 限制上传文件大小 单位MB
    fileSize: {
      type: Number,
      default: 5
    },

    /**
     * 文件类型 需要传入文件的后缀，而非文件后缀名
     * 如excel 需要传入 ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
     * 可以参考文件 src\enums\evaluateEnums.js
     */
    fileType: {
      type: Array,
      default: () => []
    },

    // 是否自动上传
    autoUpload: {
      type: Boolean,
      default: false
    },

    // 限制上传文件数量
    limit: {
      type: Number,
      default: 1
    },

    // 是否多选
    multiple: {
      type: Boolean,
      default: false
    },

    // 是否启用拖拽上传
    drag: {
      type: Boolean,
      default: false
    },

    // 提示文字
    tips: {
      type: String,
      default: ''
    },

    // 上传框内文字提示
    uploadText: {
      type: String,
      default: i18n.t('basicData.DragTheFileHereOrClickUpload')
    },

    // 是否校验文件类型
    isCheckFileType: {
      type: Boolean,
      default: false
    },

    // 是否显示文件列表
    showFileList: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      fileList: []
    };
  },

  computed: {
    // 文件类型
    accept() {
      if (this.fileType.length === 0) {
        return '';
      } else {
        return this.fileType.join(',');
      }
    }
  },

  watch: {
    fileArr: {
      handler(val) {
        if (val.length !== 0) {
          this.fileList = val;
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // 文件上传
    enclosureUpload(option) {
      const file = option.file;
      console.log('上传文件', file);
      uploadOos(file, 'workOrder').then(res => {
        if (res.code === 200) {
          const obj = {
            name: file.name,
            url: res.url
          };
          this.fileList.push(obj);
          this.$emit('change', this.fileList);
          this.$message.success(`${file.name} ${this.$t('basicData.uploadSuccessful')}`);
        }
      }).catch(() => {
        this.$message.error(`${file.name} ${this.$t('basicData.uploadFailed')}`);
      });
    },

    // 上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeUpload(file) {
      const fileSize = file.size / 1024 / 1024 > this.fileSize;
      console.log(this.fileType, file.type, file.size, file.name);
      // 上传的文件大小不能超过 5MB
      if (fileSize) {
        this.$message.warning(this.$t('basicData.fileSizeExceedsLimit', { size: this.fileSize }));
        return false;
      }

      // 上传的文件类型限制
      if (this.isCheckFileType) {
        const fileType = ['image/png', 'image/jpeg', 'image/bmp', 'application/pdf'];
        const isBool = fileType.includes(file.type);
        if (!isBool) {
          this.$message.warning(this.$t('basicData.invalidFileFormat'));
          return false;
        }
      }
      return true;
    },

    // 资源上传数量限制
    handleExceed() {
      this.$message.warning(this.$t('basicData.fileSelectionLimit', { size: this.limit }));
    },

    // 添加未确定删除文件
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('change', this.fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    // 开始上传
    // handleUpload() {
    //   this.$refs.resourcesUp.submit();
    // },

    // 清空列表
    clearFiles() {
      this.fileList = [];
      this.$refs.resourcesUp.clearFiles();
    }
  }

};
</script>

<style lang="scss" scoped>
</style>
